import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { supabase } from '../supabase';

const AdminAuthContext = createContext(null);

function normalizeEmail(email) {
  return (email ?? '').trim().toLowerCase();
}

export function AdminAuthProvider({ children }) {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  const adminEmail = normalizeEmail(process.env.REACT_APP_ADMIN_EMAIL);

  const isAdmin = useMemo(() => {
    if (!session?.user?.email) return false;
    return normalizeEmail(session.user.email) === adminEmail && adminEmail.length > 0;
  }, [session, adminEmail]);

  useEffect(() => {
    if (!adminEmail) {
      setLoading(false);
      return;
    }

    supabase.auth.getSession().then(({ data: { session: s } }) => {
      setSession(s);
      setLoading(false);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, s) => {
      setSession(s);
    });

    return () => subscription.unsubscribe();
  }, [adminEmail]);

  const value = useMemo(
    () => ({
      session,
      loading,
      isAdmin,
      adminEmail,
    }),
    [session, loading, isAdmin, adminEmail]
  );

  return <AdminAuthContext.Provider value={value}>{children}</AdminAuthContext.Provider>;
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) {
    throw new Error('useAdminAuth must be used within AdminAuthProvider');
  }
  return ctx;
}
